<template>
  <Button
    :icon="currentTheme === 'dark' ? 'pi pi-sun' : 'pi pi-moon'"
    text
    class="theme-toggle"
    @click="toggleTheme"
    :title="currentTheme === 'dark' ? 'Перемкнути на світлу тему' : 'Перемкнути на темну тему'"
  />
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ThemeToggle',
  computed: {
    ...mapState(['currentTheme'])
  },
  methods: {
    ...mapActions(['changeTheme']),
    
    toggleTheme() {
      const newTheme = this.currentTheme === 'light' ? 'dark' : 'light'
      
      // Update theme in Vuex store
      this.changeTheme(newTheme)
      
      // Emit event to parent component
      this.$emit('theme-changed', newTheme)
      
      // Show toast notification
      if (this.$toast) {
        this.$toast.add({
          severity: 'info',
          summary: 'Тема змінена',
          detail: newTheme === 'dark' ? 'Перемкнуто на темну тему' : 'Перемкнуто на світлу тему',
          life: 2000
        })
      }
    }
  }
}
</script>

<style scoped>
.theme-toggle {
  color: var(--text-color);
  border: 1px solid var(--surface-border);
  border-radius: 6px;
  padding: 0.5rem;
  transition: all 0.3s ease;
  background: transparent;
}

.theme-toggle:hover {
  background: var(--surface-hover);
  border-color: var(--primary-color);
  transform: scale(1.05);
}

/* Dark theme overrides */
[data-theme="dark"] .theme-toggle {
  color: var(--text-color);
  border-color: var(--surface-border);
}

[data-theme="dark"] .theme-toggle:hover {
  background: var(--surface-hover);
  border-color: var(--primary-color);
}
</style> 